import useU2000AxiosNonAuthenticated from '../../axios/U2000UseAxiosNonAuthenticated';
import { useU2000AuthContext } from '../../context/auth/U2000UseAuthContext';

const LOGICALUNIT_URL = 'U2001';
const AUTHENTICATE_MFA_URL = LOGICALUNIT_URL + '/authenticate/mfa';

type LoginResponse = any;
type MenuType = any;
type MfaAuthenticateFn = (
  mfaChallengeToken: string,
  code: string,
  menu: MenuType,
) => Promise<LoginResponse>;

/** BL-0413 — 2e étape login TOTP / code de secours. */
const useU2000MfaAuthenticate = (): MfaAuthenticateFn => {
  const { prelogin, login } = useU2000AuthContext();
  const u2000AxiosNonAuthenticated = useU2000AxiosNonAuthenticated();

  const doMfaAuthenticate: MfaAuthenticateFn = async (mfaChallengeToken, code, menu) => {
    const response = await u2000AxiosNonAuthenticated.post(
      AUTHENTICATE_MFA_URL,
      JSON.stringify({ mfaChallengeToken, code }),
    );

    let result: LoginResponse = null;
    if (
      response.data.changePasswordOnLogin ||
      (response.data.organizations && response.data.organizations.length > 1)
    ) {
      result = prelogin(response.data);
    } else {
      result = login(response.data, menu);
    }
    return result;
  };

  return doMfaAuthenticate;
};

export default useU2000MfaAuthenticate;
